export default "__VITE_ASSET__Cjs6D0Gp__"